import { Draggable } from 'react-beautiful-dnd';
import React, { useState } from 'react';
import './styles/TaskView.css';
import EditTaskForm from './EditTaskForm';

const Task = ({task, index, user, setUser}) => {
    const [isHovered, setHover] = useState(false)
    const [inEdit, setEdit] = useState(false)

    const showEditForm = () => {setEdit(true)}
    const hideEditForm = () => {setEdit(false)}

    return (
        <Draggable draggableId={task.taskID.toString()} index={index}>
            {provided => (
                // Outer Div Wraps Edit Form with task.
                // Allows the form to be independent of the draggable unit.
                <div className="task-wrapper"> 
                    {inEdit && <EditTaskForm user={user} setUser={setUser} taskToEdit={task} dismiss={hideEditForm}/>}

                    <div ref={provided.innerRef}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                        onMouseEnter={() => setHover(true)}
                        onMouseLeave={() => setHover(false)}>
                            <div style={{ backgroundColor: task.color }} className = "task">
                                <label className = "task-label">{task.name}</label>
                                {isHovered && <div className = "btn task-options" onClick={showEditForm}>...</div>}
                            </div>
                    </div>
                </div>
            )}
        </Draggable>
    )
}

export default Task
